import moment, { type MomentInput } from 'moment';

import { STANDARD_TIME_FORMAT, TIME_FORMATS_BY_LOCALE, type TimeFormat } from '@wecasa/i18n/src/locales/time-formats';
import { getI18nLocale } from '@wecasa/i18n/src/translator';

const getLocaleTimeFormatting = () => TIME_FORMATS_BY_LOCALE[getI18nLocale()];

export const getStandardTimeFormat = () => STANDARD_TIME_FORMAT;

export const formatTimeDeprecated = (value: MomentInput, format: TimeFormat = 'time_default') => {
  const formats = getLocaleTimeFormatting();
  return (moment.isMoment(value) ? value : moment(value)).format(formats[format]);
};

export const formatStandardTimeDeprecated = (value: MomentInput) =>
  (moment.isMoment(value) ? value : moment(value)).format(getStandardTimeFormat());

export const formatTimeFromNowDeprecated = (value: MomentInput) =>
  (moment.isMoment(value) ? value : moment(value)).fromNow();

export const parseTimeDeprecated = (value?: string) => moment(value, getStandardTimeFormat(), true);

export const formatDurationInSecondsToHoursMinutes = (durationInSeconds?: string | number | null) => {
  if (!durationInSeconds) return '';
  // moment.utc will return a 01/01/1970 hh:mm datetime and then
  // the value of hh:mm will be used for the formatted duration
  const time = typeof durationInSeconds === 'string' ? parseInt(durationInSeconds, 10) : durationInSeconds;

  return formatTimeDeprecated(moment.utc(time * 1000));
};
